import React from 'react'
import SubmitButton from '../../Form/SubmitButton'

const Button = props => (
  <SubmitButton
    {...props}
    onClick={props.onClick || props.onClickHandler}
    size="medium"
  />
)

export default Button

export { Button }



// WEBPACK FOOTER //
// ./src/Components/Buttons/Button/index.js